import '@ids/style-button';
import './Button.css';

import type { ButtonType } from '../../global-types/Content';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  buttonType: ButtonType | undefined;
};

function Button({ buttonType, ...props }: ButtonProps) {
  const variant = buttonType ?? 'filled';
  return <button type={'button'} className={`if button ${variant} size-w-100p`} {...props} />;
}

export default Button;
